module.exports = __webpack_public_path__ + "img/221.9c857c16.jpg";